@if (this.fusionService.selectedYoutube && this.fusionService.selectedYoutube.metadata.videoId) {
<div class="fusion-container">
  <!-- ===== INTRO ===== -->
  <div class="fusion-intro">
    <div class="fusion-logo-icon">
      <i class="ri-youtube-line"></i>
    </div>
    <div>
      <h5
        class="mb-0"
        i18n="@@youtube-heading"
      >YouTube-Video</h5>
      <small
        class="text-muted"
        i18n="@@youtube-intro-description"
      >
        Verbinde ein YouTube-Video mit diesem Fusion-View.
      </small>
    </div>
  </div>
  <hr class="fusion-divider" />
  <!-- ===== TITEL + IDENTIFIKATOR ===== -->
  <section class="fusion-section">
    <h6
      class="fusion-section-title"
      i18n="@@title"
    >Titel</h6>
    <input
      pInputText
      type="text"
      [(ngModel)]="this.fusionService.selectedYoutube.metadata.title"
      [ngModelOptions]="{ updateOn: 'blur' }"
      (ngModelChange)="this.fusionService.updateFusionFieldFor(this.fusionService.selectedYoutube._id, 'title', this.fusionService.selectedYoutube.metadata.title)"
      class="w-100"
    >
    <small class="fusion-section-hint mt-1 d-block">
      <span i18n="@@fusion-view-name">Identifikator</span>: {{ this.fusionService.selectedYoutube.metadata.name }}
    </small>
  </section>
  <hr class="fusion-divider" />
  <div class="fusion-sections">
    <!-- ===== 1. VIDEO-URL + PLAYER-EINSTELLUNGEN ===== -->
    <section class="fusion-section">
      <h6
        class="fusion-section-title"
        i18n="@@youtube-url-heading"
      >Video-URL</h6>
      <div class="video-url-row">
        @if (this.safeHtml !== '') {
        <div class="video-preview">
          <iframe [src]="this.safeHtml"></iframe>
        </div>
        }
        <div class="video-url-controls">
          <div class="d-flex gap-2 align-items-start mb-3">
            <input
              pInputText
              #urlInput
              type="text"
              pSize="small"
              class="flex-fill"
              placeholder="https://"
              [value]="'https://www.youtube.com/watch?v=' + this.fusionService.selectedYoutube.metadata.videoId"
            />
            <p-button
              size="small"
              severity="primary"
              (onClick)="this.addYoutube(urlInput.value)"
              i18n-label="@@use"
              label="Verwenden"
            ></p-button>
          </div>

          <!-- Player-Einstellungen (wichtig) -->
          <h6
            class="fusion-section-title mt-2"
            i18n="@@youtube-player-settings"
          >Player-Einstellungen</h6>

          <div class="d-flex flex-column gap-3">
            <!-- Autoplay -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedYoutube.metadata.pv_autoplay === 1"
                (onChange)="this.fusionService.selectedYoutube.metadata.pv_autoplay = $event.checked ? 1 : 0; this.fusionService.updateFusionField('pv_autoplay', this.fusionService.selectedYoutube.metadata.pv_autoplay)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-autoplay"
              >Autoplay</label>
            </div>
            <!-- Loop -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedYoutube.metadata.pv_loop === 1"
                (onChange)="this.fusionService.selectedYoutube.metadata.pv_loop = $event.checked ? 1 : 0; this.fusionService.updateFusionField('pv_loop', this.fusionService.selectedYoutube.metadata.pv_loop)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-loop"
              >Loop</label>
            </div>
            <!-- Nutzersteuerung -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedYoutube.metadata.pv_controls === 1"
                (onChange)="this.fusionService.selectedYoutube.metadata.pv_controls = $event.checked ? 1 : 0; this.fusionService.updateFusionField('pv_controls', this.fusionService.selectedYoutube.metadata.pv_controls)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-controls"
              >Nutzersteuerung</label>
            </div>
            <!-- Vollbild erlauben -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedYoutube.metadata.pv_fs === 1"
                (onChange)="this.fusionService.selectedYoutube.metadata.pv_fs = $event.checked ? 1 : 0; this.fusionService.updateFusionField('pv_fs', this.fusionService.selectedYoutube.metadata.pv_fs)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-fullscreen"
              >Vollbild erlauben</label>
            </div>
          </div>
          <!-- Erweitert Toggle -->
          <button
            class="advanced-toggle mt-3"
            (click)="this.showAdvanced = !this.showAdvanced"
          >
            <i [class]="this.showAdvanced ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
            <span i18n="@@youtube-advanced-settings">Erweiterte Einstellungen</span>
          </button>
          @if (this.showAdvanced) {
          <div class="d-flex flex-column gap-3 mt-3">
            <!-- Tastatursperre -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedYoutube.metadata.pv_disablekb === 1"
                (onChange)="this.fusionService.selectedYoutube.metadata.pv_disablekb = $event.checked ? 1 : 0; this.fusionService.updateFusionField('pv_disablekb', this.fusionService.selectedYoutube.metadata.pv_disablekb)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-disablekeyboard"
              >Tastatursperre</label>
            </div>
            <!-- Globale Videoempfehlungen -->
            <div class="display-option-toggle">
              <p-toggleswitch
                [ngModel]="this.fusionService.selectedYoutube.metadata.pv_rel === 1"
                (onChange)="this.fusionService.selectedYoutube.metadata.pv_rel = $event.checked ? 1 : 0; this.fusionService.updateFusionField('pv_rel', this.fusionService.selectedYoutube.metadata.pv_rel)"
              ></p-toggleswitch>
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-rel"
              >Globale Videoempfehlungen</label>
            </div>
            <!-- Start Position -->
            <div class="display-option-field">
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-start"
              >Start Position Sekunden</label>
              <div class="d-flex align-items-center gap-2">
                @if(this.fusionService.selectedYoutube.metadata.pv_start !== 'default') {
                <p-checkbox
                  [binary]="true"
                  [ngModel]="true"
                  (change)="this.fusionService.selectedYoutube.metadata.pv_start = 'default'; this.fusionService.updateFusionField('pv_start','default')"
                ></p-checkbox>
                <input
                  pInputText
                  #startInput
                  type="number"
                  pSize="small"
                  class="flex-fill"
                  (change)="this.fusionService.updateFusionField('pv_start',startInput.valueAsNumber)"
                  [(ngModel)]="this.fusionService.selectedYoutube.metadata.pv_start"
                >
                } @else {
                <p-checkbox
                  [binary]="true"
                  [ngModel]="false"
                  (change)="this.fusionService.selectedYoutube.metadata.pv_start = 1; this.fusionService.updateFusionField('pv_start',1)"
                ></p-checkbox>
                <span
                  class="text-muted"
                  i18n="@@youtube-default"
                >Standard</span>
                }
              </div>
            </div>
            <!-- End Position -->
            <div class="display-option-field">
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-end"
              >End Position</label>
              <div class="d-flex align-items-center gap-2">
                @if(this.fusionService.selectedYoutube.metadata.pv_end !== 'default') {
                <p-checkbox
                  [binary]="true"
                  [ngModel]="true"
                  (change)="this.fusionService.selectedYoutube.metadata.pv_end = 'default'; this.fusionService.updateFusionField('pv_end','default')"
                ></p-checkbox>
                <input
                  pInputText
                  #endInput
                  type="number"
                  pSize="small"
                  class="flex-fill"
                  (change)="this.fusionService.updateFusionField('pv_end',endInput.valueAsNumber)"
                  [(ngModel)]="this.fusionService.selectedYoutube.metadata.pv_end"
                >
                } @else {
                <p-checkbox
                  [binary]="true"
                  [ngModel]="false"
                  (change)="this.fusionService.selectedYoutube.metadata.pv_end = 1; this.fusionService.updateFusionField('pv_end',1)"
                ></p-checkbox>
                <span
                  class="text-muted"
                  i18n="@@youtube-default"
                >Standard</span>
                }
              </div>
            </div>
            <!-- Annotationen -->
            <div class="display-option-field">
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-annotations"
              >Annotationen anzeigen</label>
              <p-select
                [options]="this.annotationOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedYoutube.metadata.pv_iv_load_policy"
                [ngModelOptions]="{updateOn: 'blur'}"
                (ngModelChange)="this.fusionService.updateFusionField('pv_iv_load_policy', this.fusionService.selectedYoutube.metadata.pv_iv_load_policy)"
              ></p-select>
            </div>
            <!-- Fortschrittsbalkenfarbe -->
            <div class="display-option-field">
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-progressbarcolor"
              >Fortschrittsbalkenfarbe</label>
              <p-select
                [options]="this.progressColorOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedYoutube.metadata.pv_color"
                [ngModelOptions]="{updateOn: 'blur'}"
                (ngModelChange)="this.fusionService.updateFusionField('pv_color', this.fusionService.selectedYoutube.metadata.pv_color)"
              ></p-select>
            </div>
            <!-- Untertitel -->
            <div class="display-option-field">
              <label
                class="form-label fw-semibold mb-0"
                i18n="@@youtube-playervars-closed-captions-load"
              >Untertitel</label>
              <p-select
                [options]="this.captionOptions"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="this.fusionService.selectedYoutube.metadata.pv_cc_load_policy"
                [ngModelOptions]="{updateOn: 'blur'}"
                (ngModelChange)="this.fusionService.updateFusionField('pv_cc_load_policy', this.fusionService.selectedYoutube.metadata.pv_cc_load_policy)"
              ></p-select>
            </div>
          </div>
          }
        </div>
      </div>
    </section>
    <hr class="fusion-divider" />
    <section class="fusion-section">
      <h6
        class="fusion-section-title"
        i18n="@@fusionconfig-display-options"
      >Darstellungsoptionen (Initial)</h6>
      <small
        class="fusion-section-hint"
        i18n="@@fusionconfig-display-options-hint"
      >
        Lege fest, wie der Bot und der Inhalt im Fusion-View dargestellt werden.
      </small>
      <div class="display-options-row">
        <div class="display-options-controls">
          <!-- Ansichtsmodus -->
          <div class="display-option-field">
            <p-select
              id="pvViewModeSelect"
              [options]="this.viewModeOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="this.fusionService.selectedYoutube.metadata.viewMode"
              [ngModelOptions]="{updateOn: 'blur'}"
              (ngModelChange)="this.fusionService.updateFusionField('viewMode', this.fusionService.selectedYoutube.metadata.viewMode)"
            ></p-select>
          </div>
          <!-- Bot-Typ -->
          <div class="display-option-field">
            <p-selectbutton
              [options]="this.botTypeOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="this.fusionService.selectedYoutube.metadata.bottype"
              (ngModelChange)="this.fusionService.updateFusionField('bottype',this.fusionService.selectedYoutube.metadata.bottype)"
              [unselectable]="true"
            >
              <ng-template
                let-item
                pTemplate="item"
              >
                <i
                  [class]="item.icon"
                  class="me-1"
                ></i>
                <span>{{ item.label }}</span>
              </ng-template>
            </p-selectbutton>
          </div>
          <!-- Bot anzeigen -->
          <div class="display-option-toggle">
            <p-toggleswitch
              [ngModel]="!this.fusionService.selectedYoutube.metadata.botHidden"
              (ngModelChange)="this.fusionService.selectedYoutube.metadata.botHidden = !$event; this.fusionService.updateFusionField('botHidden', this.fusionService.selectedYoutube.metadata.botHidden)"
            ></p-toggleswitch>
            <label
              class="form-label fw-semibold mb-0"
              i18n="@@fusionconfig-bot-visible"
            >Bot anzeigen</label>
          </div>
          <!-- Bot-Button anzeigen -->
          <div class="display-option-toggle">
            <p-toggleswitch
              [ngModel]="!this.fusionService.selectedYoutube.metadata.botButtonHidden"
              (ngModelChange)="this.fusionService.selectedYoutube.metadata.botButtonHidden = !$event; this.fusionService.updateFusionField('botButtonHidden', this.fusionService.selectedYoutube.metadata.botButtonHidden)"
            ></p-toggleswitch>
            <label
              class="form-label fw-semibold mb-0"
              i18n="@@fusionconfig-bot-button-visible"
            >Bot-Button anzeigen</label>
          </div>

          <!-- Disclaimer-Platzierung -->
          <div class="display-option-toggle">
            <p-toggleswitch
              [ngModel]="this.fusionService.selectedYoutube.metadata.disclaimerPlacement === 'fusionview'"
              (ngModelChange)="this.fusionService.selectedYoutube.metadata.disclaimerPlacement = $event ? 'fusionview' : 'botview'; this.fusionService.updateFusionField('disclaimerPlacement', this.fusionService.selectedYoutube.metadata.disclaimerPlacement)"
            ></p-toggleswitch>
            <label
              class="form-label fw-semibold mb-0"
              i18n="@@fusionconfig-disclaimer-over-fusionview"
            >Disclaimer über Fusion-View</label>
          </div>

          <!-- Systemsprache -->
          <div class="display-option-toggle">
            <label
              class="form-label fw-semibold mb-0"
              for="youtubeLangSelect"
              i18n="@@fusionconfig-systemlang"
            >Systemsprache</label>
            <p-select
              id="youtubeLangSelect"
              [options]="this.systemLanguageOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="this.fusionService.selectedYoutube.metadata.botlang"
              (ngModelChange)="this.fusionService.updateFusionField('botlang', this.fusionService.selectedYoutube.metadata.botlang)"
            ></p-select>
          </div>
        </div>
        <!-- Preview Wireframe -->
        <div class="display-preview">
          <div class="display-preview-frame">
            @if (this.fusionService.selectedYoutube.metadata.viewMode === 'split' ||
            !this.fusionService.selectedYoutube.metadata.viewMode) {
            <div class="preview-split">
              <div class="preview-content-area">
                <div class="preview-content-line"></div>
                <div class="preview-content-line short"></div>
                <div class="preview-content-line"></div>
              </div>
              @if (!this.fusionService.selectedYoutube.metadata.botHidden) {
              <div class="preview-bot-area">
                <div class="preview-bot-header"></div>
                <div class="preview-bot-messages">
                  <div class="preview-bot-bubble"></div>
                  <div class="preview-bot-bubble user"></div>
                </div>
                <div class="preview-bot-input"></div>
              </div>
              }
            </div>
            }
            @if (this.fusionService.selectedYoutube.metadata.viewMode === 'split-reverse') {
            <div class="preview-split-reverse">
              <div class="preview-content-area">
                <div class="preview-content-line"></div>
                <div class="preview-content-line short"></div>
                <div class="preview-content-line"></div>
              </div>
              @if (!this.fusionService.selectedYoutube.metadata.botHidden) {
              <div class="preview-bot-area">
                <div class="preview-bot-header"></div>
                <div class="preview-bot-messages">
                  <div class="preview-bot-bubble"></div>
                  <div class="preview-bot-bubble user"></div>
                </div>
                <div class="preview-bot-input"></div>
              </div>
              }
            </div>
            }
            @if (this.fusionService.selectedYoutube.metadata.viewMode === 'window') {
            <div class="preview-window">
              <div class="preview-content-area full">
                <div class="preview-content-line"></div>
                <div class="preview-content-line short"></div>
              </div>
              @if (!this.fusionService.selectedYoutube.metadata.botHidden) {
              <div class="preview-bot-overlay">
                <div class="preview-bot-header"></div>
                <div class="preview-bot-messages">
                  <div class="preview-bot-bubble"></div>
                  <div class="preview-bot-bubble user"></div>
                </div>
                <div class="preview-bot-input"></div>
              </div>
              }
            </div>
            }
            @if (this.fusionService.selectedYoutube.metadata.viewMode === 'full') {
            <div class="preview-full">
              @if (!this.fusionService.selectedYoutube.metadata.botHidden) {
              <div class="preview-bot-area fullscreen">
                <div class="preview-bot-header"></div>
                <div class="preview-bot-messages">
                  <div class="preview-bot-bubble"></div>
                  <div class="preview-bot-bubble user"></div>
                  <div class="preview-bot-bubble"></div>
                </div>
                <div class="preview-bot-input"></div>
              </div>
              }
              @if (this.fusionService.selectedYoutube.metadata.botHidden) {
              <div
                class="preview-hidden-label"
                i18n="@@fusionconfig-preview-hidden"
              >Bot ausgeblendet</div>
              }
            </div>
            }
            @if (this.fusionService.selectedYoutube.metadata.viewMode === 'float') {
            <div class="preview-float">
              <div class="preview-content-area full">
                <div class="preview-content-line"></div>
                <div class="preview-content-line short"></div>
                <div class="preview-content-line"></div>
              </div>
              @if (!this.fusionService.selectedYoutube.metadata.botHidden) {
              <div class="preview-bot-float">
                <div class="preview-bot-header"></div>
                <div class="preview-bot-messages">
                  <div class="preview-bot-bubble"></div>
                  <div class="preview-bot-bubble user"></div>
                </div>
                <div class="preview-bot-input"></div>
              </div>
              }
            </div>
            }
            @if (this.fusionService.selectedYoutube.metadata.botHidden &&
            this.fusionService.selectedYoutube.metadata.viewMode !== 'full') {
            <div class="preview-hidden-overlay">
              <div class="preview-content-line"></div>
              <div class="preview-content-line short"></div>
              <div class="preview-content-line"></div>
            </div>
            }
            @if (!this.fusionService.selectedYoutube.metadata.botButtonHidden) {
            <div class="preview-bot-fab">
              <i class="ri-chat-3-line"></i>
            </div>
            }
          </div>
        </div>
      </div>
    </section>
    <hr class="fusion-divider" />
    <!-- ===== 3. LOGIK-EDITOR ===== -->
    <section class="fusion-section">
      <h6
        class="fusion-section-title"
        i18n="@@fusion-logic-editor-heading"
      >Logik-Editor</h6>
      <p
        class="fusion-section-hint"
        i18n="@@fusion-logic-editor-description"
      >
        Im Logik-Editor kannst du Abläufe und Regeln für diesen Fusion-View per Scripting anpassen.
      </p>
      <p-button
        [outlined]="true"
        severity="primary"
        size="small"
        icon="ri-code-box-line"
        [gotoBlockly]="this.editorItemService.getEditorItemByUniqueId('fusion_'+this.fusionService.selectedYoutube._id)"
        i18n-label="@@to-scripting"
        label="Zum Scripting"
      ></p-button>
    </section>
  </div>
  <!-- ===== 4. HTML-EDITOR (Erweitert) ===== -->
  @if (this.fusionService.selectedYoutube.metadata.useStaticHtml) {
  <section class="fusion-section">
    <h6 class="fusion-section-title">
      <i class="ri-code-s-slash-line me-1"></i>
      <span i18n="@@fusionconfig-html-advanced">HTML-Editor (Erweitert)</span>
    </h6>
    <p
      class="fusion-section-hint"
      i18n="@@fusionconfig-html-hint"
    >
      Hier kannst du das HTML des Fusion-Views direkt bearbeiten. Nur für erfahrene Nutzer empfohlen.
    </p>
    <p-button
      [outlined]="true"
      [severity]="showHtmlEditor ? 'primary' : 'secondary'"
      size="small"
      [icon]="showHtmlEditor ? 'ri-eye-off-line' : 'ri-code-s-slash-line'"
      (onClick)="showHtmlEditor = !showHtmlEditor"
      [label]="showHtmlEditor ? 'Editor ausblenden' : 'Editor einblenden'"
    ></p-button>
    @if (showHtmlEditor) {
    <div class="mt-3">
      <app-codemirror-html
        [code]="this.fusionService.selectedYoutube.metadata.staticHtml"
        (finish)="this.fusionService.selectedYoutube.metadata.staticHtml = $event.code; this.fusionService.updateFusionField('staticHtml', this.fusionService.selectedYoutube.metadata.staticHtml)"
      ></app-codemirror-html>
      <button
        pButton
        i18n-label="@@show-placeholders"
        label="Platzhalter anzeigen"
        icon="pi pi-info-circle"
        severity="secondary"
        size="small"
        class="mt-2"
        [appPlaceholderInfo]="'basic'"
      ></button>
    </div>
    }
  </section>
  }
</div>
}

@if (this.fusionService.selectedYoutube && !this.fusionService.selectedYoutube.metadata.videoId) {
<div class="fusion-container">
  <div class="video-empty">
    <div class="video-empty-icon">
      <i class="ri-youtube-line"></i>
    </div>
    <h5
      class="mb-1"
      i18n="@@embed-youtube"
    >YouTube-Video einbinden</h5>
    <small
      class="text-muted mb-3 d-block text-center"
      i18n="@@embed-youtube-description"
    >
      Füge eine YouTube-URL ein, um das Video mit diesem Fusion-View zu verbinden.
    </small>
    <div class="video-empty-input">
      <input
        pInputText
        #urlInput
        type="text"
        class="flex-fill"
        placeholder="https://www.youtube.com/watch?v=..."
      />
      <p-button
        size="small"
        severity="primary"
        (onClick)="this.addYoutube(urlInput.value)"
        i18n-label="@@use"
        label="Verwenden"
      ></p-button>
    </div>
  </div>
</div>
}